module.exports = __webpack_public_path__ + "static/img/3.382f0d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market101/3.png
// module id = YrOm
// module chunks = 1